export enum ReportModelType {
  CrystalReport = 0,
  DxReport,
}

export interface ReportModel {
  reportId: number;
  type: string;
  typeId: number;
  language: string;
  languageId: number;
  isActive: boolean;
  fileName: string;
  description: string;
  appType: string
  appTypeId: number;
  activity: string;
  activityId?: number;
  reportModelType: ReportModelType;
  reportName: string;
}

export interface BillingReportModel {
  reportId: number;
  description: string;
  step: number;
}

export interface RunEmployeeApplicationReportModel {
  reportId: number;
  applicationId: number;
}

export enum ReportsModule {
  applicationsGeneralReports,
  applicationReports,
  activityReports,
  billingGeneralReports,
  billingReports
}
